<template>
  <v-card :loading="loading">
    <v-card-title>
      {{i18n['are_you_ready_to_accept_quotation']}}
    </v-card-title>
    <v-card-text>
      {{i18n['note_if_accept_quotation']}}
    </v-card-text>
    <v-card-actions v-if="!loading">
      <v-spacer></v-spacer>
      <v-btn type="submit" color="error" @click="reject()">{{ i18n["reject"] }}</v-btn>
      <v-btn type="submit" color="success" @click="accept()">{{ i18n["accept"] }}</v-btn>
      <v-dialog v-model="dialog" persistent max-width="800">
        <v-card :class="arabic ? `arFont` : 'enFont'" :loading="loading">
          <v-card-title style="font-size:20px">
            {{ accept_path ? i18n['we_sent_code_to_email'] : i18n['confirm_rejection_state_reason'] }}
          </v-card-title>
          <v-card-text>
            <v-row class="align-center">
              <v-col cols="6" class="py-0" v-if="accept_path">
                <v-col cols="12"  class="py-0" v-for="(field, f) in accept_fileds" :key="'field-'+f">
                  <Field :field="field" :item="accept_data" :index="f" />
                </v-col>
                <v-col cols="12"  class="py-0" v-if="accept_data.payment_method">
                  <Field :field="imageField" :item="accept_data" @getUpload="getUpload" />
                </v-col>
                <v-col cols="12"  class="py-0" v-if="accept_data.payment_method">
                  <div v-html="payment_methods.filter(x=>x.id === accept_data.payment_method)[0].details"></div>
                </v-col>
              </v-col>
              <v-col cols="6" class="py-0" v-if="reject_path">
                <v-col cols="12"  class="py-0" v-for="(field, f) in reject_fields" :key="'field-'+f">
                  <Field :field="field" :item="rejection_data" :index="f" />
                </v-col>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click.native="close()">{{ i18n['close']}}</v-btn>
            <v-btn :loading="loading" color="primary" @click.native="confirm()" :disabled="!accept_data.code || !accept_data.payment_method || !check_attachment" v-if="accept_path">{{ i18n['confirm_accept']}}</v-btn>
            <v-btn :loading="loading" color="primary" @click.native="confirmReject()" v-if="reject_path">{{ i18n['confirm_reject']}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import Field from '@/components/Field.vue';

export default {
  components: {
    Field,
  },
  props:['po', 'rejection_reasons', 'payment_methods', 'loading'],
  data() {
    return {
      dialog:false,
      accept_path:false,
      code:null,
      accept_data:{payment_attachment_url:null},
      accept_fileds:[
        {
          name: "code",
          type: 'text',
          label: 'verification_code',
          info: { en: '', ar: '' },
        },
        {
          name: "payment_method",
          type: 'select',
          returnValue:'value',
          label: 'payment_method',
          data:[
            ...this.$props.payment_methods
          ],
          info: { en: '', ar: '' },
        
        },
      ],
      imageField: {
        name: "payment_attachment_url",
        type: 'upload',
        label: 'proof_of_payment',
        info: { en: '', ar: '' }
      },
      reject_path:false,
      rejection_data:{},
      reject_fields:[
        {
          name: "rejected_reason",
          type: 'select',
          returnValue:'value',
          label: 'rejected_reason',
          data:[
            ...this.$props.rejection_reasons
          ],
          info: { en: '', ar: '' },
        
        },
        {
          name: "rejected_reason_details",
          type: 'textarea',
          label: 'rejected_reason_details',
          conditional_key: 'rejected_reason',
          conditional_valye: 'other',
          info: { en: '', ar: '' },
        },
      ]
    }
  },
  methods:{
    getUpload(image) {
      this.accept_data.payment_attachment_url = image.value
    },
    close() {
      this.reject_path = false
      this.accept_path = false
      this.dialog = false
    },
    async accept(){
			await this.$store.dispatch('postResource', { resource: '/purchase-orders/confirm', value: {purchase_order_id:this.$props.po.id} })
      this.$store.dispatch('setSnackbar', { type:'success', message:this.i18n['verification_email_sent'] })
      this.accept_path = true
      this.dialog = true
    },
    async reject() {
      this.reject_path = true
      this.dialog = true

    },
    async confirmReject(){
      console.log(this.rejection_data)
      let r = await this.$store.dispatch('postResource', { resource: '/purchase-orders/reject', value: {purchase_order_id:this.$props.po.id, code:this.code, ...this.rejection_data} })
      this.$store.dispatch('setSnackbar', { type:r.success?'success':'error', message:this.i18n[r.message] })
      if(r.success) {
        this.dialog = false
        this.$emit('reloadData')
      }
    },
    async confirm(){
			let r = await this.$store.dispatch('postResource', { resource: '/purchase-orders/verify', value: {purchase_order_id:this.$props.po.id, ...this.accept_data} })
      this.$store.dispatch('setSnackbar', { type:r.success?'success':'error', message:this.i18n[r.message] })
      if(r.success) {
        this.dialog = false
        this.$emit('reloadData')
      } 

    }
  },
  computed: {
    check_attachment(){
      return this.accept_data.payment_attachment_url
    },
		language() {
			return this.$store.state.language;
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language];
		},
		arabic() {
			if (this.$store.state.language == "ar")
				return true;
		},
	},
}
</script>

<style>

</style>